export const moduleTemplates = [
  {
    id: 1,
    carModelId: 1,
    carModel: 'e-Golf (1st gen)',
    moduleTypeId: 3,
    moduleType: '12-cell / 4S3P',
    batteryCellManufacturerId: 1,
    batteryCellManufacturer: 'Panasonic/Sanyo',
    chemistryTypeId: 1,
    chemistryType: 'Li-ion NMC',
    cellTypeId: 1,
    cellType: 'Prismatic',
    cellNominalEntryId: 1,
    cellNominalVoltage: 3.67,
    cellNominalCapacity: 0.092,
    cellNominalResistance: 999,
    moduleNominalEntryId: 1,
    moduleNominalVoltage: 14.7,
    moduleNominalCapacity: 1.1,
    moduleNominalResistance: 999,
    productionStartYear: 2014,
    productionEndYear: 2016,
    packCapacity: 0
  },
  {
    id: 2,
    carModelId: 10,
    carModel: 'EQC',
    moduleTypeId: 4,
    moduleType: '72-cell / 3x12S2P',
    batteryCellManufacturerId: 9,
    batteryCellManufacturer: 'NMC',
    chemistryTypeId: 7,
    chemistryType: 'NMC',
    cellTypeId: 2,
    cellType: 'Pouch',
    cellNominalEntryId: 1,
    cellNominalVoltage: 3.67,
    cellNominalCapacity: 0.092,
    cellNominalResistance: 999,
    moduleNominalEntryId: 1,
    moduleNominalVoltage: 14.7,
    moduleNominalCapacity: 1.1,
    moduleNominalResistance: 999,
    productionStartYear: 2019,
    packCapacity: 12.8
  }
];

export const modules = [
  {
    id: '08d8eea0-7885-4c60-81e3-ed4f6d261c61',
    productionYear: 0,
    serialNumber: 'string',
    mileage: 0,
    chargingCycles: 0,
    events: 'string',
    retirement: 'string',
    cabinetId: '08d8eea0-787a-43d8-818d-ce63e145e0bd',
    deviceId: 20,
    moduleTemplateId: 1
  },
  {
    id: '08d8eea0-788f-4959-8e4b-7ced6bf27be0',
    productionYear: 0,
    serialNumber: 'string',
    mileage: 0,
    chargingCycles: 0,
    events: 'string',
    retirement: 'string',
    cabinetId: '08d8eea0-787a-43d8-818d-ce63e145e0bd',
    deviceId: 24,
    moduleTemplateId: 1
  },
  {
    id: '08d8eea0-7890-4084-81e7-cb8fe2a767ac',
    productionYear: 0,
    serialNumber: 'string',
    mileage: 0,
    chargingCycles: 0,
    events: 'string',
    retirement: 'string',
    cabinetId: '08d8eea0-788f-4fe0-8188-a95a469ad909',
    deviceId: 10,
    moduleTemplateId: 1
  },
  {
    id: '08d8eea0-7890-4240-8416-97661ce1d521',
    productionYear: 0,
    serialNumber: 'string',
    mileage: 0,
    chargingCycles: 0,
    events: 'string',
    retirement: 'string',
    cabinetId: '08d8eea0-788f-4fe0-8188-a95a469ad909',
    deviceId: 14,
    moduleTemplateId: 1
  },
  {
    id: '08d8fda6-0700-4623-87d0-1a204fce552d',
    productionYear: 2021,
    serialNumber: 'string',
    mileage: 0,
    chargingCycles: 0,
    events: 'string',
    retirement: 'string',
    cabinetId: '08d8fda6-06f4-4ab8-8926-5e371e1247f6',
    deviceId: 31,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8385-4edd-8080-7d15d3fe9d00',
    productionYear: 2021,
    serialNumber: 'Module 1',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8381-406f-858f-604ec11989cd',
    deviceId: 234,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838b-433d-886b-1992ed27f887',
    productionYear: 2021,
    serialNumber: 'Module 2',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8381-406f-858f-604ec11989cd',
    deviceId: 231,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838b-4815-8db4-47cd5f16bea0',
    productionYear: 2021,
    serialNumber: 'Module 3',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8381-406f-858f-604ec11989cd',
    deviceId: 228,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838b-4986-8637-651177d05161',
    productionYear: 2021,
    serialNumber: 'Module 4',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8381-406f-858f-604ec11989cd',
    deviceId: 225,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838b-4aae-8107-160f486404ce',
    productionYear: 2021,
    serialNumber: 'Module 5',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8381-406f-858f-604ec11989cd',
    deviceId: 222,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838b-4bc2-837f-9858233a42c6',
    productionYear: 2021,
    serialNumber: 'Module 6',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8381-406f-858f-604ec11989cd',
    deviceId: 256,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838b-4cce-8638-7e5986cc6e80',
    productionYear: 2021,
    serialNumber: 'Module 7',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8381-406f-858f-604ec11989cd',
    deviceId: 254,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838b-4dcd-8cd7-ae064fa8b530',
    productionYear: 2021,
    serialNumber: 'Module 8',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8381-406f-858f-604ec11989cd',
    deviceId: 251,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838b-4f8c-895d-36c6ead67659',
    productionYear: 2021,
    serialNumber: 'Module 9',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838b-4ee2-861b-e7e3d575f6da',
    deviceId: 247,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-4095-82af-f1edf30d697b',
    productionYear: 2021,
    serialNumber: 'Module 10',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838b-4ee2-861b-e7e3d575f6da',
    deviceId: 244,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-4220-854b-5845d7cd2221',
    productionYear: 2021,
    serialNumber: 'Module 11',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838b-4ee2-861b-e7e3d575f6da',
    deviceId: 241,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-4336-82b3-bb95450df886',
    productionYear: 2021,
    serialNumber: 'Module 12',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838b-4ee2-861b-e7e3d575f6da',
    deviceId: 219,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-44b9-89cf-9d591ff02a81',
    productionYear: 2021,
    serialNumber: 'Module 13',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838b-4ee2-861b-e7e3d575f6da',
    deviceId: 197,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-45cb-84a3-014ba0b397c0',
    productionYear: 2021,
    serialNumber: 'Module 14',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838b-4ee2-861b-e7e3d575f6da',
    deviceId: 194,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-46e0-8129-bd2d812b6c3f',
    productionYear: 2021,
    serialNumber: 'Module 15',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838b-4ee2-861b-e7e3d575f6da',
    deviceId: 192,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-47d9-8673-d7288827f713',
    productionYear: 2021,
    serialNumber: 'Module 16',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838b-4ee2-861b-e7e3d575f6da',
    deviceId: 188,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-4958-8609-32f8752482b8',
    productionYear: 2021,
    serialNumber: 'Module 17',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838c-48e6-84c8-63ff3ceaacfb',
    deviceId: 191,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-4a55-8ba1-1867c9fc7e28',
    productionYear: 2021,
    serialNumber: 'Module 18',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838c-48e6-84c8-63ff3ceaacfb',
    deviceId: 202,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-4b59-8380-c21f9091fd93',
    productionYear: 2021,
    serialNumber: 'Module 19',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838c-48e6-84c8-63ff3ceaacfb',
    deviceId: 215,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-4c5b-8436-d5e1d39d2ebd',
    productionYear: 2021,
    serialNumber: 'Module 20',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838c-48e6-84c8-63ff3ceaacfb',
    deviceId: 212,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-4d4e-8c44-b0661a90fed5',
    productionYear: 2021,
    serialNumber: 'Module 21',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838c-48e6-84c8-63ff3ceaacfb',
    deviceId: 209,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-4e51-8579-fd59979a3f6e',
    productionYear: 2021,
    serialNumber: 'Module 22',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838c-48e6-84c8-63ff3ceaacfb',
    deviceId: 206,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838c-4f47-8f52-9540117b1e91',
    productionYear: 2021,
    serialNumber: 'Module 23',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838c-48e6-84c8-63ff3ceaacfb',
    deviceId: 203,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-4053-8dca-638da94bc97c',
    productionYear: 2021,
    serialNumber: 'Module 24',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838c-48e6-84c8-63ff3ceaacfb',
    deviceId: 258,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-41bd-8310-6c842048c304',
    productionYear: 2021,
    serialNumber: 'Module 25',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-414f-8f61-9f83e089eefd',
    deviceId: 310,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-42be-8b5b-30e59db21d90',
    productionYear: 2021,
    serialNumber: 'Module 26',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-414f-8f61-9f83e089eefd',
    deviceId: 307,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-43b5-8fc8-aef694ab52b6',
    productionYear: 2021,
    serialNumber: 'Module 27',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-414f-8f61-9f83e089eefd',
    deviceId: 304,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-44a6-83b7-74b3d9e8c75f',
    productionYear: 2021,
    serialNumber: 'Module 28',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-414f-8f61-9f83e089eefd',
    deviceId: 301,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-45a8-860a-d439868551b7',
    productionYear: 2021,
    serialNumber: 'Module 29',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-414f-8f61-9f83e089eefd',
    deviceId: 298,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-46a5-8ebe-1d459d521702',
    productionYear: 2021,
    serialNumber: 'Module 30',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-414f-8f61-9f83e089eefd',
    deviceId: 332,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-47b4-8c68-3c16aa76f40b',
    productionYear: 2021,
    serialNumber: 'Module 31',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-414f-8f61-9f83e089eefd',
    deviceId: 330,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-48ae-82ea-eb2207ae26b6',
    productionYear: 2021,
    serialNumber: 'Module 32',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-414f-8f61-9f83e089eefd',
    deviceId: 327,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-4a25-8a3c-91a3b45eca71',
    productionYear: 2021,
    serialNumber: 'Module 33',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-49b1-8c59-22fe07bc822f',
    deviceId: 323,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-4b3c-8821-935ca5f89e45',
    productionYear: 2021,
    serialNumber: 'Module 34',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-49b1-8c59-22fe07bc822f',
    deviceId: 320,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-4c68-8333-a3ba32cab80f',
    productionYear: 2021,
    serialNumber: 'Module 35',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-49b1-8c59-22fe07bc822f',
    deviceId: 317,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-4d61-855c-c81804de356b',
    productionYear: 2021,
    serialNumber: 'Module 36',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-49b1-8c59-22fe07bc822f',
    deviceId: 296,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-4e5b-84c0-7511ead2886b',
    productionYear: 2021,
    serialNumber: 'Module 37',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-49b1-8c59-22fe07bc822f',
    deviceId: 273,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838d-4f6f-8a5e-bb73eb9d73f3',
    productionYear: 2021,
    serialNumber: 'Module 38',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-49b1-8c59-22fe07bc822f',
    deviceId: 270,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-414b-80e9-00d28c081f68',
    productionYear: 2021,
    serialNumber: 'Module 39',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-49b1-8c59-22fe07bc822f',
    deviceId: 267,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-4257-82a8-51b16ee2119c',
    productionYear: 2021,
    serialNumber: 'Module 40',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838d-49b1-8c59-22fe07bc822f',
    deviceId: 264,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-43d8-8e53-99de112f1553',
    productionYear: 2021,
    serialNumber: 'Module 41',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-434e-8bd0-b65fe701bd78',
    deviceId: 260,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-44dd-81b2-d08f1e5ccaf5',
    productionYear: 2021,
    serialNumber: 'Module 42',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-434e-8bd0-b65fe701bd78',
    deviceId: 294,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-460f-81e1-0355befc4393',
    productionYear: 2021,
    serialNumber: 'Module 43',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-434e-8bd0-b65fe701bd78',
    deviceId: 292,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-4737-8f6d-36fbf0e0c847',
    productionYear: 2021,
    serialNumber: 'Module 44',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-434e-8bd0-b65fe701bd78',
    deviceId: 289,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-482c-8e6d-00af3ac1d7aa',
    productionYear: 2021,
    serialNumber: 'Module 45',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-434e-8bd0-b65fe701bd78',
    deviceId: 286,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-493b-8b82-74b4d67d1cb8',
    productionYear: 2021,
    serialNumber: 'Module 46',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-434e-8bd0-b65fe701bd78',
    deviceId: 283,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-4a30-8cb9-f4145f874c62',
    productionYear: 2021,
    serialNumber: 'Module 47',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-434e-8bd0-b65fe701bd78',
    deviceId: 280,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-4b37-801a-6378faf9f748',
    productionYear: 2021,
    serialNumber: 'Module 48',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-434e-8bd0-b65fe701bd78',
    deviceId: 295,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-4c96-8d92-d036c657e3c5',
    productionYear: 2021,
    serialNumber: 'Module 49',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-4c2b-8a58-502f0f58b81d',
    deviceId: 84,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-4d9a-8fdf-13397aab3a4a',
    productionYear: 2021,
    serialNumber: 'Module 50',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-4c2b-8a58-502f0f58b81d',
    deviceId: 81,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-4e8c-8ce4-3c60b98a343b',
    productionYear: 2021,
    serialNumber: 'Module 51',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-4c2b-8a58-502f0f58b81d',
    deviceId: 78,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838e-4f8b-865b-d36e28275bd3',
    productionYear: 2021,
    serialNumber: 'Module 52',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-4c2b-8a58-502f0f58b81d',
    deviceId: 75,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-408a-8190-cf2c0e2c8137',
    productionYear: 2021,
    serialNumber: 'Module 53',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-4c2b-8a58-502f0f58b81d',
    deviceId: 72,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-4177-8f07-b7f58ddeb0bf',
    productionYear: 2021,
    serialNumber: 'Module 54',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-4c2b-8a58-502f0f58b81d',
    deviceId: 88,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-4276-82e1-feb1f3699da4',
    productionYear: 2021,
    serialNumber: 'Module 55',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-4c2b-8a58-502f0f58b81d',
    deviceId: 104,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-4369-8043-54e6d5237228',
    productionYear: 2021,
    serialNumber: 'Module 56',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838e-4c2b-8a58-502f0f58b81d',
    deviceId: 101,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-44d4-8bff-aaceb7806d36',
    productionYear: 2021,
    serialNumber: 'Module 57',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-445a-86da-8202d0169305',
    deviceId: 97,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-45c9-89cc-4ccc01f8f1d1',
    productionYear: 2021,
    serialNumber: 'Module 58',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-445a-86da-8202d0169305',
    deviceId: 94,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-46c5-8df4-440e435c5d9c',
    productionYear: 2021,
    serialNumber: 'Module 59',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-445a-86da-8202d0169305',
    deviceId: 91,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-47c8-86fe-4843b560f52e',
    productionYear: 2021,
    serialNumber: 'Module 60',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-445a-86da-8202d0169305',
    deviceId: 69,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-48b8-8c14-58a1cae97678',
    productionYear: 2021,
    serialNumber: 'Module 61',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-445a-86da-8202d0169305',
    deviceId: 47,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-49c0-8785-68894e6d5a3f',
    productionYear: 2021,
    serialNumber: 'Module 62',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-445a-86da-8202d0169305',
    deviceId: 44,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-4ab3-8f85-bda7bb727e8b',
    productionYear: 2021,
    serialNumber: 'Module 63',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-445a-86da-8202d0169305',
    deviceId: 48,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-4ba4-80f0-6f8d3e82acdd',
    productionYear: 2021,
    serialNumber: 'Module 64',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-445a-86da-8202d0169305',
    deviceId: 38,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-4d33-8812-00658a9e5632',
    productionYear: 2021,
    serialNumber: 'Module 65',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-4cca-82c1-11ca27dd77b5',
    deviceId: 34,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-4e24-89c0-90d758c1ad9e',
    productionYear: 2021,
    serialNumber: 'Module 66',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-4cca-82c1-11ca27dd77b5',
    deviceId: 50,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-838f-4f28-83e2-792f0aff68b5',
    productionYear: 2021,
    serialNumber: 'Module 67',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-4cca-82c1-11ca27dd77b5',
    deviceId: 65,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-4018-89b0-baf6389215cc',
    productionYear: 2021,
    serialNumber: 'Module 68',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-4cca-82c1-11ca27dd77b5',
    deviceId: 62,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-411a-887b-645ce5ccd395',
    productionYear: 2021,
    serialNumber: 'Module 69',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-4cca-82c1-11ca27dd77b5',
    deviceId: 59,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-420e-812f-6bd07c25db22',
    productionYear: 2021,
    serialNumber: 'Module 70',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-4cca-82c1-11ca27dd77b5',
    deviceId: 56,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-42ff-8161-5274ddf8acc2',
    productionYear: 2021,
    serialNumber: 'Module 71',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-4cca-82c1-11ca27dd77b5',
    deviceId: 53,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-4400-8d84-80c271577009',
    productionYear: 2021,
    serialNumber: 'Module 72',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-838f-4cca-82c1-11ca27dd77b5',
    deviceId: 106,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-455d-85c7-6473f8d3a9e0',
    productionYear: 2021,
    serialNumber: 'Module 73',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-44f4-815d-54e591f9b5ba',
    deviceId: 160,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-4660-8eba-3f501b689741',
    productionYear: 2021,
    serialNumber: 'Module 74',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-44f4-815d-54e591f9b5ba',
    deviceId: 157,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-4751-856b-bb7f555590ae',
    productionYear: 2021,
    serialNumber: 'Module 75',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-44f4-815d-54e591f9b5ba',
    deviceId: 154,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-4850-8c75-70c1b27e1fde',
    productionYear: 2021,
    serialNumber: 'Module 76',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-44f4-815d-54e591f9b5ba',
    deviceId: 151,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-4953-87f0-da0256b36d6a',
    productionYear: 2021,
    serialNumber: 'Module 77',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-44f4-815d-54e591f9b5ba',
    deviceId: 148,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-4a42-8130-10a9dcc54440',
    productionYear: 2021,
    serialNumber: 'Module 78',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-44f4-815d-54e591f9b5ba',
    deviceId: 164,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-4b44-881c-a37863ba6597',
    productionYear: 2021,
    serialNumber: 'Module 79',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-44f4-815d-54e591f9b5ba',
    deviceId: 180,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-4cb7-8bc8-8ea5202b62f7',
    productionYear: 2021,
    serialNumber: 'Module 80',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-44f4-815d-54e591f9b5ba',
    deviceId: 177,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-4e31-8514-3adcb0c5010d',
    productionYear: 2021,
    serialNumber: 'Module 81',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-4dc5-8e7e-d79295c69f59',
    deviceId: 173,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8390-4f2f-8063-1c91355ca9ca',
    productionYear: 2021,
    serialNumber: 'Module 82',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-4dc5-8e7e-d79295c69f59',
    deviceId: 170,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-4032-84a4-b877e44eb6ef',
    productionYear: 2021,
    serialNumber: 'Module 83',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-4dc5-8e7e-d79295c69f59',
    deviceId: 167,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-4122-8db1-4c9e9bf09505',
    productionYear: 2021,
    serialNumber: 'Module 84',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-4dc5-8e7e-d79295c69f59',
    deviceId: 163,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-4225-8d2f-023e87adc472',
    productionYear: 2021,
    serialNumber: 'Module 85',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-4dc5-8e7e-d79295c69f59',
    deviceId: 123,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-4318-834c-45e6b859f82c',
    productionYear: 2021,
    serialNumber: 'Module 86',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-4dc5-8e7e-d79295c69f59',
    deviceId: 120,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-4412-8d1e-5b4c8bc16312',
    productionYear: 2021,
    serialNumber: 'Module 87',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-4dc5-8e7e-d79295c69f59',
    deviceId: 117,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-451a-85aa-a278d13bd430',
    productionYear: 2021,
    serialNumber: 'Module 88',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8390-4dc5-8e7e-d79295c69f59',
    deviceId: 114,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-4682-8e77-da406df80a63',
    productionYear: 2021,
    serialNumber: 'Module 89',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8391-4619-8901-14eed1f542a0',
    deviceId: 110,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-478b-85cc-8fbf66bb2006',
    productionYear: 2021,
    serialNumber: 'Module 90',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8391-4619-8901-14eed1f542a0',
    deviceId: 126,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-4880-82a1-a05be64f533c',
    productionYear: 2021,
    serialNumber: 'Module 91',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8391-4619-8901-14eed1f542a0',
    deviceId: 142,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-4997-874f-d834898ee4be',
    productionYear: 2021,
    serialNumber: 'Module 92',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8391-4619-8901-14eed1f542a0',
    deviceId: 139,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-4a8b-8064-eae88a710e47',
    productionYear: 2021,
    serialNumber: 'Module 93',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8391-4619-8901-14eed1f542a0',
    deviceId: 136,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-4b85-83cc-30395eb74512',
    productionYear: 2021,
    serialNumber: 'Module 94',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8391-4619-8901-14eed1f542a0',
    deviceId: 133,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8391-4c84-8802-4cdae9f3d425',
    productionYear: 2021,
    serialNumber: 'Module 95',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8391-4619-8901-14eed1f542a0',
    deviceId: 130,
    moduleTemplateId: 1
  },
  {
    id: '08d90498-8392-4613-8d60-87f0a6c27821',
    productionYear: 2021,
    serialNumber: 'Module 96',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90498-8391-4619-8901-14eed1f542a0',
    deviceId: 182,
    moduleTemplateId: 1
  },
  {
    id: '08d90ec3-b27f-4d2a-8f71-c9ee25234740',
    productionYear: 2021,
    serialNumber: 'Module 1',
    mileage: 1,
    chargingCycles: 1,
    events: '1',
    retirement: '1',
    cabinetId: '08d90ec3-b277-46d3-8d40-2cbad3eeb785',
    deviceId: 341,
    moduleTemplateId: 1
  }
];
